import { useEffect } from "react";
import { useGetPermitIssueTrendMetric } from "../operations/queries/getPermitIssueTrendMetric";
import RegisterPermitIssueTrend from "../components/RegisterPermitIssueTrend";
import { useAppContext } from "../hooks/useAppContext";
import { PermitMetricScopeInput } from "../operations/queries/getPermitsCountByStatesMetric";

interface Props {
  scope?: PermitMetricScopeInput;
}

const RegisterPermitIssueTrendContainer = (props: Props) => {
  const { currentOrganization, currentPermitRegister } = useAppContext();

  const { getPermitIssueTrendMetric, data } = useGetPermitIssueTrendMetric();

  useEffect(() => {
    if (currentOrganization) {
      const activeScope: PermitMetricScopeInput = props.scope || {
        organizationId: currentOrganization.id,
        registerIds: currentPermitRegister?.id ? [currentPermitRegister.id] : null,
      };

      getPermitIssueTrendMetric({
        variables: { query: { scope: activeScope } },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization, currentPermitRegister, props.scope]);

  if (!data) return null;

  // Groups arrive ordered by value; restore chronological order using the sortable
  // "yyyy-MM" dimension key, then split it back into the {year, month, count} the chart expects.
  const trendData = [...data.permitIssueTrendMetric.groups]
    .sort((a, b) => a.dimensionKey.localeCompare(b.dimensionKey))
    .map((group) => {
      const [year, month] = group.dimensionKey.split("-").map((part) => parseInt(part, 10));
      return { year, month, count: group.value.value };
    });

  return <RegisterPermitIssueTrend data={trendData} />;
};

export default RegisterPermitIssueTrendContainer;
